import { get, post, put } from './api/http.service';

/**
 * Get invited users
 */
export const getInvitedUsers = () => {
  return get('/ccs/v1/user/avatar');
};

/**
 * Update user avatar name
 */
export const updateUserAvatarName = (name, id) => {
  return put('/ccs/v1/user/avatar/name', { name, id });
};

export const getUserAvatarList = (params) => {
  return get('/ccs/v1/user/avatar/list', params);
};

export const revokeTokens = async (cognitoAccessToken, targetAccessToken) => {
  try {
    return post('/ccs/v1/user/accessToken/revoke', {
      cognitoAccessToken,
      targetAccessToken,
    });
  } catch (error) {
    console.error('Failed to revoke tokens:', error);
    return { error };
  }
};
